module.exports = __webpack_public_path__ + "img/sushi-roll.3b1b3bfa.svg";